/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Ai_Actions_300Inputs */

const en_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI actions / month`)
};

const de_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 KI-Aktionen / Monat`)
};

const fr_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 actions IA / mois`)
};

const es_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 acciones IA / mes`)
};

const it_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 azioni IA / mese`)
};

const nl_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-acties / maand`)
};

const pl_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 akcji AI / miesiac`)
};

const fi_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-toimintoa / kuukausi`)
};

const da_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-handlinger / maned`)
};

const sv_pricing_feature_ai_actions_300 = /** @type {(inputs: Pricing_Feature_Ai_Actions_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-handlingar / manad`)
};

/**
* | output |
* | --- |
* | "300 AI actions / month" |
*
* @param {Pricing_Feature_Ai_Actions_300Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_ai_actions_300 = /** @type {((inputs?: Pricing_Feature_Ai_Actions_300Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Ai_Actions_300Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_ai_actions_300(inputs)
	if (locale === "fr") return fr_pricing_feature_ai_actions_300(inputs)
	if (locale === "es") return es_pricing_feature_ai_actions_300(inputs)
	if (locale === "it") return it_pricing_feature_ai_actions_300(inputs)
	if (locale === "nl") return nl_pricing_feature_ai_actions_300(inputs)
	if (locale === "pl") return pl_pricing_feature_ai_actions_300(inputs)
	if (locale === "fi") return fi_pricing_feature_ai_actions_300(inputs)
	if (locale === "da") return da_pricing_feature_ai_actions_300(inputs)
	if (locale === "sv") return sv_pricing_feature_ai_actions_300(inputs)
	return en_pricing_feature_ai_actions_300(inputs)
});